import { getAllTestsInfo } from "../../core/actions/labActions";
import { useDispatch, useSelector } from "react-redux";
import { format, utcToZonedTime } from "date-fns-tz";
import { labActions } from "../../core/actions";

export function getschemafromBloodSugarProfile(templateId, schema, flags) {
  console.log("flags", flags);
  console.log(templateId);
  console.log("schema : ", schema);

  let jsonSchema = {};
  let elementName1;
  let obj1 = {};
  let obj2 = {};
  let elementName2;
  jsonSchema["properties"] = {};

  for (let content of schema.content) {
    console.log("content: ", content);

    for (let datas of content.data.events) {
      console.log("content data: ", datas);

      for (let item of datas.data.items) {
        console.log("inside data items: ", item);

        if (item._type === "ELEMENT") {
          elementName1 = item.value.value;
          console.log("elementName1", elementName1);

          jsonSchema["properties"][elementName1] = {};

          obj1 = { type: "object" };
          jsonSchema["properties"][elementName1] = obj1;

          jsonSchema["properties"][elementName1]["properties"] = {};

          console.log("jsonschema: ", jsonSchema);
        } else if (item._type === "CLUSTER") {
          for (let it of item.items) {
            console.log("it", it);

            elementName2 = it.name.value;
            console.log("element2: ", elementName2);

            jsonSchema["properties"][elementName1]["properties"][elementName2] =
              {};
            console.log("jsonSchema2 :", jsonSchema);

            switch (elementName2) {
              case "Result":
                obj2 =
                  flags === "editComposition"
                    ? {
                        type: "string",
                        default: it.value.magnitude + " " + it.value.units,
                      }
                    : { type: "string", default: "0" };
                jsonSchema["properties"][elementName1]["properties"][
                  elementName2
                ] = obj2;
                break;

              case "Comment":
                let defaultValue =
                  flags === "editComposition" ? it.value.value : "";
                let commentenum = {
                  type: "string",
                  enum: ["High", "Low", defaultValue],
                  enumNames: ["High", "Low", defaultValue],
                  default: defaultValue,
                };
                jsonSchema["properties"][elementName1]["properties"][
                  elementName2
                ] = obj2;
                jsonSchema["properties"][elementName1]["properties"][
                  elementName2
                ] = commentenum;
                break;

              case "Ref. Range":
                let obj3 = { type: "string", default: it.value.value };
                jsonSchema["properties"][elementName1]["properties"][
                  elementName2
                ] = obj3;
                break;
            }
          }
        }
      }
    }
  }
  console.log("Jsonschema: ", jsonSchema);
  return jsonSchema;
}

export function getschemafromNewLabTests(templateId, schema, flags) {
  console.log("flags", flags);
  console.log(templateId);
  console.log("schema : ", schema);

  let jsonSchema = {};
  let elementName1;
  let obj1 = {};
  let obj2 = {};
  let elementName2;

  jsonSchema["properties"] = {};

  for (let content of schema.content) {
    console.log("content: ", content);

    for (let datas of content.data.events) {
      console.log("content data: ", datas);

      const items = datas.data.items;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        console.log("inside data items: ", item);

        if (item._type === "ELEMENT") {
          if (item.name.value === "Test") {
            elementName1 = item.value.value;
            jsonSchema["properties"][elementName1] = {
              type: "object",
              properties: {},
            };

            const isLast = i === items.length - 1;

            if (isLast) {
              // Process previous 3 items
              const start = Math.max(0, i - 3);
              for (let j = start; j < i; j++) {
                const prevItem = items[j];
                if (prevItem._type === "ELEMENT") {
                  const key = prevItem.name.value;
                  jsonSchema["properties"][elementName1]["properties"][key] = {
                    type: "string",
                    textarea: [prevItem.value.value],
                    default: prevItem.value.value,
                  };
                }
              }
            }
            // Else, keep processing next items normally
            continue;
          }

          // Process only after Test is found
          if (elementName1) {
            elementName2 = item.name.value;
            obj2 = {
              type: "string",
              textarea: [item.value.value],
              default: item.value.value,
            };
            jsonSchema["properties"][elementName1]["properties"][elementName2] =
              obj2;
            console.log("jsonschema: ", jsonSchema);
          }

          console.log("elementName1", elementName1);
        }
      }
    }
  }

  console.log("Jsonschema: ", jsonSchema);
  return jsonSchema;
}

export async function getschemafromMultiLabReports(
  templateId,
  schema,
  flags,
  notes,
  removetests
) {
  console.log("flags", flags);
  console.log("templateId", templateId);
  console.log("removetests:", removetests);
  const jsonSchema = { properties: {} };
  let majorTest = null;
  for (let content of schema.content) {
    for (let datas of content.data.events) {
      if (datas.time._type === "DV_DATE_TIME") {
        datas.time.value = format(
          utcToZonedTime(new Date(), "Asia/Kolkata"),
          "yyyy-MM-dd'T'HH:mm:ssXXX"
        );
      }
      for (let item of datas.data.items) {
        // Create a new package (majorTest)
        if (item._type === "ELEMENT" && item.name.value !== "COMMENT") {
          majorTest = item.value.value;
          if (!jsonSchema.properties[majorTest]) {
            jsonSchema.properties[majorTest] = {
              type: "object",
              title: majorTest,
              properties: {},
            };
          }
        }

        // Add COMMENT once per package
        if (item.name.value === "COMMENT") {
          jsonSchema.properties["COMMENT"] = {
            type: "string",
            default: item.value?.value || "",
          };
        }

        // Handle each test under the package
        if (item._type === "CLUSTER") {
          let elementName2 = null;
          let unit;

          // Sort so "Analyte name" comes first
          item.items.sort((a, b) => {
            if (a.name.value === "Analyte name") return -1;
            if (b.name.value === "Analyte name") return 1;
            return b.name.value.localeCompare(a.name.value);
          });

          for (let eachElement of item.items) {
            const name = eachElement.name.value;

            if (name === "Analyte name") {
              elementName2 = eachElement.value.value;
              if (!jsonSchema["properties"][elementName2]) {
                jsonSchema["properties"][elementName2] = {
                  type: "object",
                  properties: {},
                };
              }
            } else if (name === "Analyte result") {
              if (eachElement.value._type === "DV_TEXT") {
                let commentenum = {};
                if (flags == "editComposition") {
                  let emptyValue = "";
                  let defaultValue = eachElement.value.value || "";
                  const test = await getAllTestsInfo(elementName2, notes);
                  console.log("tests", test);
                  // for (let test of tests) {
                  //   if (test.testname === elementName2) {
                  let val = test?.value;
                  if (val === undefined || val === "") {
                    const resultObj = {
                      type: "string",
                      default: String(defaultValue),
                    };
                    jsonSchema["properties"][elementName2].properties[
                      "Analyte result"
                    ] = resultObj;
                    unit = eachElement.value.units;
                  } else {
                    let defvalue =
                      defaultValue.trim() === ""
                        ? ""
                        : defaultValue
                            .split(",")
                            .map((val) => val.trim())
                            .filter((val) => !/^unit\(/i.test(val))
                            .join(",");
                    let value = val.split(",").map((val) => val.trim());
                    let unitValue = null;
                    const unitMatch = defaultValue.match(/unit\(([^)]+)\)/i);
                    if (unitMatch) {
                      unitValue = unitMatch[1];
                      unit = unitValue;
                    }
                    commentenum = {
                      type: "string",
                      enum: [...value, emptyValue],
                      enumNames: [...value, emptyValue],
                      default: defvalue,
                    };
                    jsonSchema["properties"][elementName2].properties[
                      "Analyte result"
                    ] = commentenum;
                  }
                  //   }

                  // }
                } else {
                  let defaultValue = "";
                  let values = eachElement.value.value || "";
                  if (values.trim() === "") {
                    const resultObj = { type: "string", default: "" };
                    jsonSchema["properties"][elementName2].properties[
                      "Analyte result"
                    ] = resultObj;
                  } else {
                    let value = values
                      .split(",")
                      .map((val) => val.trim())
                      .filter((val) => !/^unit\(/i.test(val));
                    let unitValue = null;
                    const unitMatch = values.match(/unit\(([^)]+)\)/i);
                    if (unitMatch) {
                      unitValue = unitMatch[1];
                    }
                    commentenum = {
                      type: "string",
                      enum: [...value, defaultValue],
                      enumNames: [...value, defaultValue],
                      default: defaultValue,
                    };
                    unit = unitValue;
                    jsonSchema["properties"][elementName2].properties[
                      "Analyte result"
                    ] = commentenum;
                  }
                }
                if (unit === null || unit === "null" || unit === undefined) {
                  unit = "";
                }
                jsonSchema["properties"][elementName2].properties["Units"] = {
                  type: "string",
                  default: unit,
                };
              } else {
                unit = eachElement.value.units;
                const displayValue =
                  eachElement.value.magnitude === 0
                    ? ""
                    : eachElement.value.magnitude;
                const resultObj =
                  flags === "editComposition"
                    ? { type: "string", default: String(displayValue) }
                    : { type: "string", default: "" };
                jsonSchema["properties"][elementName2].properties[
                  "Analyte result"
                ] = resultObj;
                jsonSchema["properties"][elementName2].properties["Units"] = {
                  type: "string",
                  default: unit,
                };
              }
            } else if (name === "Reference range guidance") {
              jsonSchema["properties"][elementName2].properties[
                "Reference range guidance"
              ] = {
                type: "string",
                default: eachElement.value.value,
              };
            }
          }
        }
      }
    }
  }
  // Do nothing if removetests is empty or not provided
  if (Array.isArray(removetests) && removetests.length > 0) {
    const allowedTests = new Set(removetests);

    const filteredProperties = {};

    Object.keys(jsonSchema.properties).forEach((key) => {
      if (key === "COMMENT" || allowedTests.has(key)) {
        filteredProperties[key] = jsonSchema.properties[key];
      }
    });

    jsonSchema.properties = filteredProperties;
  }

  console.log("Final JSON Schema:", jsonSchema);
  return jsonSchema;
}

const bloodSugarProfile = {
  getschemafromBloodSugarProfile,
  getschemafromNewLabTests,
  getschemafromMultiLabReports,
};

export default bloodSugarProfile;
